import { useState, useEffect } from "react";
import { Users, Plus } from "lucide-react";

import { GROUP_TABS, INTERACTION_TYPES } from "../consts";
import { callApi, getCourseLabel } from "../utils";
import GroupDetails from "./group-details";
import GroupWizard from "./group-wizard";

/* ---------------------------------------------------------------------- */
/*  Кабинет преподавателя                                                  */
/* ---------------------------------------------------------------------- */

export default function TeacherWorkspace() {
  const [wizardOpen, setWizardOpen] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState();
  const [tab, setTab] = useState(GROUP_TABS.overview);
  const [teacherGroups, setTeacherGroups] = useState([]);
  const [allTeachers, setAllTeachers] = useState([]);

  const getGroups = (groupId) => {
    callApi({
      method: "GET",
      path: "api/teacher/practice-groups",
      needAuth: true,
    }).then((response) => {
      if (response.error) {
        console.error(response.error);
      } else {
        const respArr = response.response;
        if (respArr) {
          setTeacherGroups(respArr);
          if (respArr.length) {
            if (groupId) {
              const group = respArr.find((elem) => elem.id === groupId);
              if (group) setSelectedGroup(group);
            } else {
              if (!selectedGroup) setSelectedGroup(respArr[0]);
            }
          }
        } else {
          console.error(respArr);
        }
      }
    });
  };

  useEffect(() => {
    getGroups();

    callApi({
      method: "GET",
      path: "api/teachers",
      needAuth: true,
    }).then((response) => {
      if (response.error) {
        console.error(response.error);
      } else {
        const respArr = response.response;
        if (respArr) {
          setAllTeachers(respArr);
        } else {
          console.error(respArr);
        }
      }
    });
  }, []);

  const handleCreate = (groupId) => {
    getGroups(groupId);
    setWizardOpen(false);
    setTab(GROUP_TABS.overview);
  };

  const renderGroupList = () => {
    if (!teacherGroups.length) {
      return <p className="muted small">У вас пока нет групп.</p>;
    }

    return teacherGroups.map((g) => (
      <button
        key={g.id}
        className={
          "sidebar-item" + (g.id === selectedGroup?.id ? " active" : "")
        }
        onClick={() => {
          setSelectedGroup(g);
          setTab(GROUP_TABS.overview);
        }}
      >
        <div className="si-top">
          <Users size={14} />
          <span>{g.group}</span>
          {!g.owner && <span className="tag">связ.</span>}
        </div>
        <div className="si-sub">
          {getCourseLabel(g.course)} ·{" "}
          {g.interactionType === INTERACTION_TYPES.individual
            ? "индивидуальный"
            : "групповой"}
        </div>
        <div className="si-sub">{`работ на проверке: ${g.pendingReviewCount}`}</div>
      </button>
    ));
  };

  return (
    <div className="workspace">
      <aside className="sidebar">
        <button
          className="btn primary block"
          onClick={() => setWizardOpen(true)}
        >
          <Plus size={16} /> Добавить группу
        </button>
        <div className="sidebar-list">{renderGroupList()}</div>
      </aside>

      <GroupDetails
        allTeachers={allTeachers}
        getGroups={getGroups}
        selectedGroup={selectedGroup}
        tab={tab}
        setTab={setTab}
      />

      {wizardOpen && (
        <GroupWizard
          onCancel={() => setWizardOpen(false)}
          onCreate={handleCreate}
        />
      )}
    </div>
  );
}
